import React, { Component } from "react";
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;

class ExportPDF extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataSet: [],
            type: '',
            filename: '',

            documentDefinition: {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                content: [],
                dontBreakRows: true,
                pageMargins: [30, 50, 30, 50],
                defaultStyle: {
                    fontSize: 10
                },
                startPosition: {
                    horizontalRatio: 0.2
                }
            }

        }

    }

    componentDidMount() {

        this.setState({
            dataSet: this.props.data,
            filename: this.props.filename,
            display: this.props.display,
            allDesigs: this.props.allDesigs
        }, () => {
            this._exportPdfTable();
        });
    }

    componentWillUnmount() {
        this._exportPdfTable();
    }

    // not using yet on 13 Jan
    generateDate() {
        return moment().format('DD/MM/YYYY hh:mm:ss A');
    }

    renderTotalRow = (total) => {

        var totalRow = []
        totalRow.push({ text: 'Total:', alignment: "right", bold: true })
        totalRow.push({ text: '$' + numberWithCommas_display(total), alignment: "right", bold: true })

        return totalRow

    }

    renderDonationTotal = (total) => {
        var rows = [];

        // console.log(total)
        var totalRow = [''];
        totalRow.push({ text: 'Total:', alignment: "left", bold: true });

        totalRow.push({ text: '$' + numberWithCommas_display(total.totalDonation), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.totalCredit), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.totalCheque), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.totalNetDonation), alignment: "right", bold: true });
        rows.push(totalRow);
        
        return rows
    }


    renderSinAdmin = (sectionData) => {

        var rows = [];
        var dataRows = sectionData.rows
        var total = sectionData.total

        for (var i = 0; i < dataRows.length; i++) {

            var data = dataRows[i];
            var row = []
            row.push({ text: Object.keys(data)[0], alignment: "left" })
            row.push({ text: '$' + numberWithCommas_display(Object.values(data)[0]), alignment: "right" })

            rows.push(row)

        }

        rows.push(this.renderTotalRow(total));
        return rows;


    }


    renderDonation = (sectionData) => {

        var rows = [];
        var dataRows = sectionData.rows
        var total = sectionData.total

        var donationTable = this.renderDonationTable(dataRows);
        rows = rows.concat(donationTable);

        var donationTotalRows = this.renderDonationTotal(total)
        rows = rows.concat(donationTotalRows);
        return rows;

    }

    renderBudgets = (budgets) => {

        var rows = [];

        for (var i = 0; i < budgets.length; i++) {

            var budget = budgets[i];

            let { allDesigs } = this.state;
            var desigId = budget.sourceDesig;
            var bankName = budget.sourceBankName;
            var desigName = allDesigs[desigId];
            var startDate = budget.planStartDate;
            var endDate = budget.planEndDate;

            var sourceRow = [
                { text: 'Source Fund: ' + desigName, alignment: "left", colSpan: 7 },
                '', '', '', '', '', ''
            ]
            rows.push(sourceRow)

            var bankRow = [
                { text: 'Linked Bank Account: ' + bankName, alignment: "left", colSpan: 7 },
                '', '', '', '', '', ''
            ]
            rows.push(bankRow)

            var startDateRow = [
                { text: 'Project Start Date: ' + startDate, alignment: "left", colSpan: 7 },
                '', '', '', '', '', ''
            ]
            rows.push(startDateRow)

            var endDateRow = [
                { text: 'Project End Date: ' + endDate, alignment: "left", colSpan: 7 },
                '', '', '', '', '', ''
            ]
            rows.push(endDateRow)

            var fundTable = this.renderFundTable(budget.rows);
            rows = rows.concat(fundTable);

            var fundTotalRows = this.renderFundTotal(budget)
            rows = rows.concat(fundTotalRows);


        }

        return rows

    }

    renderDonationTable = (donations) => {

        var columnRow = [];

        columnRow.push({ text: 'Account Name', alignment: "left" })
        columnRow.push({ text: 'Transfer to Bank Account', alignment: "left" })
        columnRow.push({ text: 'Donations', alignment: "right" })
        columnRow.push({ text: 'Credit Card Charges', alignment: "right" })
        columnRow.push({ text: 'Cheque Charges', alignment: "right" })
        columnRow.push({ text: 'Net Donations', alignment: "right" })

        var rows = [columnRow];

        for (var i = 0; i < donations.length; i++) {

            var donation = donations[i];
            var donationRow = [
                { text: donation.DesigName, alignment: "left" },
                { text: "Office", alignment: "left" },
                { text: '$' + numberWithCommas_display(donation.Donation), alignment: "right" },
                { text: '$' + numberWithCommas_display(donation.Credit), alignment: "right" },
                { text: '$' + numberWithCommas_display(donation.Cheque), alignment: "right" },
                { text: '$' + numberWithCommas_display(donation.NetDonation), alignment: "right" }
            ]
            rows.push(donationRow);

        }

        return rows
    }

    renderFundTable = (funds) => {

        var columnRow = [];

        columnRow.push({ text: 'Account Name', alignment: "left" })
        columnRow.push({ text: 'Transfer to Bank Account', alignment: "left" })
        columnRow.push({ text: 'Percentage (%)', alignment: "right" })
        columnRow.push({ text: 'Donations', alignment: "right" })
        columnRow.push({ text: 'Credit Card Charges', alignment: "right" })
        columnRow.push({ text: 'Cheque Charges', alignment: "right" })
        columnRow.push({ text: 'Net Donations', alignment: "right" })

        var rows = [columnRow];

        for (var i = 0; i < funds.length; i++) {

            var fund = funds[i];
            var fundRow = (!("OfficeDonationAcc" in fund)) ? [
                { text: fund.FundAccName, alignment: "left" },
                { text: fund.BankAccName, alignment: "left" },
                { text: numberWithCommas_display(fund.Per), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.Donation), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.Credit), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.Cheque), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.NetDonation), alignment: "right" }
            ] : [
                { text: fund.DesigName, alignment: "left" },
                { text: "Office", alignment: "left" },
                { text: '$' + numberWithCommas_display(fund.Donation), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.Credit), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.Cheque), alignment: "right" },
                { text: '$' + numberWithCommas_display(fund.NetDonation), alignment: "right" }
            ]
            rows.push(fundRow);

        }

        return rows
    }


    renderFundTotal = (budget) => {

        var rows = [];
        var total = budget.adjustTotal;
        var correctTotal = budget.total;

        var totalRow = ['', ''];
        totalRow.push({ text: 'Total:', alignment: "right", bold: true });

        totalRow.push({ text: '$' + numberWithCommas_display(total.donations), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.credit), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.cheque), alignment: "right", bold: true });
        totalRow.push({ text: '$' + numberWithCommas_display(total.netdonations), alignment: "right", bold: true });

        rows.push(totalRow);

        if ((numberWithCommas_display(total.donations) !== numberWithCommas_display(correctTotal.donations))
            || (numberWithCommas_display(total.credit) !== numberWithCommas_display(correctTotal.credit))
            || (numberWithCommas_display(total.cheque) !== numberWithCommas_display(correctTotal.cheque))
            || (numberWithCommas_display(total.netdonations) !== numberWithCommas_display(correctTotal.netdonations))) {

            var correctRow = ['', ''];
            correctRow.push({ text: 'Source Fund Total:', alignment: "left", color: 'red' });
            correctRow.push({ text: '$' + numberWithCommas_display(correctTotal.donations), alignment: "right", color: 'red', bold: true });
            correctRow.push({ text: '$' + numberWithCommas_display(correctTotal.credit), alignment: "right", color: 'red', bold: true });
            correctRow.push({ text: '$' + numberWithCommas_display(correctTotal.cheque), alignment: "right", color: 'red', bold: true });
            correctRow.push({ text: '$' + numberWithCommas_display(correctTotal.netdonations), alignment: "right", color: 'red', bold: true });
            rows.push(correctRow);

        }

        return rows
    }


    renderTransfers = (transfers) => {

        var rows = [];

        for (var i = 0; i < transfers.length; i++) {

            var transfer = transfers[i];

            var source = transfer.source;
            var destination = transfer.destination;
            var amount = transfer.amount;

            if (source !== destination) {

                var row = [
                    { text: 'Total amount transfer from ' + source + ' account to ' + destination + ' account:', alignment: "left", bold: true },
                    { text: '$' + numberWithCommas_display(amount), alignment: "right", bold: true }
                ]
                rows.push(row)

            }
        }

        return rows

    }


    _exportPdfTable = () => {
        const { dataSet } = this.state;
        const { filename } = this.state;
        const { display } = this.state;

        // console.log('funds transfer report PDF',dataSet, filename);
        const sinAdmin = dataSet.sinAdmin;
        const donation = dataSet.donation;
        const budgets = dataSet.budgets;
        const transfers = dataSet.transfers;


        var sinAdminTable;
        var donationTable;
        var budgetsTable;
        var transfersTable;


        if (sinAdmin) {
            sinAdminTable = this.renderSinAdmin(sinAdmin);
        }
        else {
            sinAdminTable = [['No Record Found', '']]
        }

        if (donation) {
            donationTable = this.renderDonation(donation);
        }
        else {
            donationTable = [['No Record Found', '']]
        }

        if (budgets) {
            budgetsTable = this.renderBudgets(budgets);
        }
        else {
            budgetsTable = [['No Record Found', '', '', '', '', '', '']]
        }

        if (transfers) {
            transfersTable = this.renderTransfers(transfers);
        }
        else {
            transfersTable = [['No Record Found', '']]
        }


        var sinAdminTitle = [[display.sinAdmin, '']];
        sinAdminTable = sinAdminTitle.concat(sinAdminTable);

        const donationTitle = [[{ text: display.donation, alignment: "left", colSpan: 6 }, '', '', '', '', '']];
        donationTable = donationTitle.concat(donationTable);

        const budgetsTitle = [[{ text: display.budgets, alignment: "left", colSpan: 7 }, '', '', '', '', '', '']];

        budgetsTable = budgetsTitle.concat(budgetsTable);

        const transfersTitle = [[{ text: display.transfers, bold: true }, '']];
        transfersTable = transfersTitle.concat(transfersTable);


        const title = {
            text: filename,
            alignment: 'center',
            bold: true, fontSize: 16
        }

        var sinAdminSection = {
            table: {
                widths: ['80%', '20%'],
                //   heights:heights,
                headerRows: 1,
                //   dontBreakRows: true,
                body: sinAdminTable
            },
            layout: 'headerLineOnly'
        }

        var donationSection = {
            table: {
                widths: ['20%', '20%', '15%', '15%', '15%', '15%'],
                headerRows: 1,
                body: donationTable
            },
            layout: 'headerLineOnly'
        }


        var budgetsSection = {
            table: {
                widths: ['14%', '16%', '14%', '14%', '14%', '14%', '14%'],
                headerRows: 1,
                body: budgetsTable
            },
            dontBreakRows: true,
            layout: 'headerLineOnly'
        }

        var transfersSection = {
            table: {
                widths: ['80%', '20%'],
                headerRows: 1,
                body: transfersTable
            },
            layout: 'headerLineOnly'
        }

        var content = [title, sinAdminSection, donationSection, budgetsSection, transfersSection];

        // console.log('content', content)

        this.setState({ documentDefinition: { ...this.state.documentDefinition, content: content } });

    }

    onClick = () => {
        var documentDefinition = this.state.documentDefinition;
        const { vfs } = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        return pdfMake.createPdf(documentDefinition).open();
    }

    render() {
        return (<button className='btn btn-primary' type="button" onClick={this.onClick.bind()}>Download PDF</button>)
    }


}


export default ExportPDF;